export default __webpack_public_path__ + "assets/c9033c55006bb2a4f55da9a52f59feed.png";